// src/hooks/useIsMobile.jsx
import { useEffect, useState } from "react";

// If you're on Next.js app router, you can add:
// 'use client';

export default function useIsMobile(breakpoint = 768) {
  const getMatch = () =>
    typeof window !== "undefined" &&
    window.matchMedia(`(max-width:${breakpoint}px)`).matches;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mql = window.matchMedia(`(max-width:${breakpoint}px)`);
    const onChange = (e) => setIsMobile(e.matches);

    // init (handles SSR hydration + first render)
    setIsMobile(mql.matches);

    // modern browsers
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange); // Safari < 14

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [breakpoint]);

  return isMobile;
}
